module.exports = __webpack_public_path__ + "media/fundal gland polyp.8a32aafa.wav";